import React from "react";
import { formatMoney, getStatusBadgeClass, getStatusLabel } from "./utils";

export default function ServicesManagerPanel({
  services,
  servicesEnabled,
  freelancerProfile,
  onGoToApplication,
  serviceForm,
  updateServiceField,
  resetServiceForm,
  savingService,
  handleSaveService,
  handleEditService,
  handleDeleteService,
  isAdmin,
  isAr,
  isMobile,
}) {
  return (
    <div className="card border-0 shadow-sm mb-4 provider-center__panel-card">
      <div className="card-body">
        <div className="pc-section-head mb-3">
          <div className="pc-section-head__left">
            <span className="pc-icon-box pc-icon-box--blue">
              <i className="bi bi-briefcase" />
            </span>
            <h5 className="mb-0">{isAr ? "إدارة الخدمات" : "Manage services"}</h5>
          </div>
          <span className="badge text-bg-light">{services.length}</span>
        </div>

        {!servicesEnabled ? (
          <div className="alert alert-warning mb-0">
            {isAr
              ? "قسم الخدمات معطل حاليًا من الإدارة."
              : "The services section is currently disabled from admin settings."}
          </div>
        ) : !isAdmin && !freelancerProfile ? (
          <div>
            <div className="text-muted mb-3">
              {isAr
                ? "أرسل طلب اعتماد كمقدم خدمة أولًا، وبعد الموافقة ستتمكن من إضافة خدماتك هنا."
                : "Apply as a freelancer first. Once approved, you will be able to submit services here."}
            </div>
            <button className="btn btn-dark" type="button" onClick={onGoToApplication}>
              {isAr ? "التقديم كمقدم خدمة" : "Apply as freelancer"}
            </button>
          </div>
        ) : !isAdmin && freelancerProfile.status !== "approved" ? (
          <div>
            <div className="text-muted mb-3">
              {isAr
                ? "ملف مقدم الخدمة ما زال بانتظار موافقة الإدارة."
                : "Your freelancer profile is still waiting for admin approval."}
            </div>
            <button className="btn btn-outline-secondary" type="button" onClick={onGoToApplication}>
              {isAr ? "عرض طلب الاعتماد" : "View application"}
            </button>
          </div>
        ) : (
          <>
            <div className="alert alert-info">
              {isAr
                ? "أي خدمة جديدة أو تعديل على خدمة حالية سيُعاد إلى حالة المراجعة قبل النشر."
                : "Any new service or update to an existing one will be sent back for admin review before publishing."}
            </div>

            <form onSubmit={handleSaveService}>
              <div className="row g-3">
                <div className="col-12 col-md-6">
                  <label className="form-label">{isAr ? "عنوان الخدمة بالعربية" : "Title Arabic"}</label>
                  <input
                    className="form-control"
                    value={serviceForm.titleAr}
                    onChange={(event) => updateServiceField("titleAr", event.target.value)}
                  />
                </div>
                <div className="col-12 col-md-6">
                  <label className="form-label">{isAr ? "عنوان الخدمة بالإنجليزية" : "Title English"}</label>
                  <input
                    className="form-control"
                    value={serviceForm.titleEn}
                    onChange={(event) => updateServiceField("titleEn", event.target.value)}
                  />
                </div>
                <div className="col-12 col-md-6">
                  <label className="form-label">{isAr ? "وصف مختصر بالعربية" : "Short Description Arabic"}</label>
                  <textarea
                    rows="2"
                    className="form-control"
                    value={serviceForm.shortDescriptionAr}
                    onChange={(event) => updateServiceField("shortDescriptionAr", event.target.value)}
                  />
                </div>
                <div className="col-12 col-md-6">
                  <label className="form-label">{isAr ? "وصف مختصر بالإنجليزية" : "Short Description English"}</label>
                  <textarea
                    rows="2"
                    className="form-control"
                    value={serviceForm.shortDescriptionEn}
                    onChange={(event) => updateServiceField("shortDescriptionEn", event.target.value)}
                  />
                </div>
                <div className="col-12">
                  <label className="form-label">{isAr ? "الوصف بالعربية" : "Description Arabic"}</label>
                  <textarea
                    rows="3"
                    className="form-control"
                    value={serviceForm.descriptionAr}
                    onChange={(event) => updateServiceField("descriptionAr", event.target.value)}
                  />
                </div>
                <div className="col-12">
                  <label className="form-label">{isAr ? "الوصف بالإنجليزية" : "Description English"}</label>
                  <textarea
                    rows="3"
                    className="form-control"
                    value={serviceForm.descriptionEn}
                    onChange={(event) => updateServiceField("descriptionEn", event.target.value)}
                  />
                </div>
                <div className="col-12 col-md-3">
                  <label className="form-label">{isAr ? "السعر" : "Price"}</label>
                  <input
                    type="number"
                    min="0"
                    step="0.01"
                    className="form-control"
                    value={serviceForm.price}
                    onChange={(event) => updateServiceField("price", event.target.value)}
                  />
                </div>
                <div className="col-12 col-md-3">
                  <label className="form-label">{isAr ? "العملة" : "Currency"}</label>
                  <input
                    className="form-control"
                    maxLength={3}
                    value={serviceForm.currency}
                    onChange={(event) =>
                      updateServiceField("currency", event.target.value.toUpperCase())
                    }
                  />
                </div>
                <div className="col-12 col-md-3">
                  <label className="form-label">{isAr ? "مدة التسليم بالأيام" : "Delivery Days"}</label>
                  <input
                    type="number"
                    min="1"
                    className="form-control"
                    value={serviceForm.deliveryDays}
                    onChange={(event) => updateServiceField("deliveryDays", event.target.value)}
                  />
                </div>
                <div className="col-12 col-md-3">
                  <label className="form-label">{isAr ? "عدد المراجعات" : "Revisions"}</label>
                  <input
                    type="number"
                    min="0"
                    className="form-control"
                    value={serviceForm.revisions}
                    onChange={(event) => updateServiceField("revisions", event.target.value)}
                  />
                </div>
                <div className="col-12 col-md-8">
                  <label className="form-label">{isAr ? "صورة الغلاف" : "Cover Image"}</label>
                  <input
                    className="form-control"
                    value={serviceForm.coverImage}
                    onChange={(event) => updateServiceField("coverImage", event.target.value)}
                    placeholder={isAr ? "رابط الصورة أو اسم الملف" : "Image URL or stored filename"}
                  />
                </div>
                <div className="col-12 col-md-4 d-flex align-items-end">
                  <div className="form-check mb-2">
                    <input
                      id="provider-service-active"
                      type="checkbox"
                      className="form-check-input"
                      checked={serviceForm.isActive}
                      onChange={(event) => updateServiceField("isActive", event.target.checked)}
                    />
                    <label className="form-check-label" htmlFor="provider-service-active">
                      {isAr ? "الخدمة نشطة" : "Service is active"}
                    </label>
                  </div>
                </div>
              </div>

              <div className="d-flex gap-2 mt-3">
                <button className="btn btn-dark" type="submit" disabled={savingService}>
                  {savingService
                    ? isAr
                      ? "جارٍ الحفظ..."
                      : "Saving..."
                    : serviceForm.id
                      ? isAr
                        ? "تحديث وإعادة إرسال"
                        : "Update and Resubmit"
                      : isAr
                        ? "إرسال الخدمة"
                        : "Submit Service"}
                </button>
                {serviceForm.id ? (
                  <button className="btn btn-outline-secondary" type="button" onClick={resetServiceForm}>
                    {isAr ? "إلغاء" : "Cancel"}
                  </button>
                ) : null}
              </div>
            </form>

            <hr className="my-4" />

            {services.length === 0 ? (
              <div className="text-muted">
                {isAr ? "لا توجد خدمات مضافة حتى الآن." : "No services have been submitted yet."}
              </div>
            ) : isMobile ? (
              <div className="provider-center__mobile-list">
                {services.map((service) => (
                  <article className="provider-center__mobile-item" key={service.id}>
                    <div className="provider-center__mobile-head">
                      <div>
                        <div className="fw-semibold">
                          {service.titleEn || service.titleAr || `#${service.id}`}
                        </div>
                        <div className="small text-muted">
                          {formatMoney(service.price, service.currency)}
                          {service.rejectionReason ? ` · ${service.rejectionReason}` : ""}
                        </div>
                      </div>
                      <span className={`badge rounded-pill ${getStatusBadgeClass(service.approvalStatus)}`}>
                        {getStatusLabel(service.approvalStatus, isAr)}
                      </span>
                    </div>
                    <div className="provider-center__mobile-grid">
                      <div>
                        <div className="small text-muted">{isAr ? "الطلبات" : "Orders"}</div>
                        <div>{service.ordersCount}</div>
                      </div>
                      <div>
                        <div className="small text-muted">{isAr ? "التسليم" : "Delivery"}</div>
                        <div>{service.deliveryDays} {isAr ? "يوم" : "days"}</div>
                      </div>
                    </div>
                    <div className="provider-center__mobile-actions">
                      <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => handleEditService(service)}>
                        {isAr ? "تعديل" : "Edit"}
                      </button>
                      <button type="button" className="btn btn-sm btn-outline-danger" onClick={() => handleDeleteService(service)}>
                        {isAr ? "حذف" : "Delete"}
                      </button>
                    </div>
                  </article>
                ))}
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table align-middle mb-0">
                  <thead>
                    <tr>
                      <th>{isAr ? "الخدمة" : "Service"}</th>
                      <th>{isAr ? "الحالة" : "Approval"}</th>
                      <th>{isAr ? "السعر" : "Price"}</th>
                      <th>{isAr ? "الطلبات" : "Orders"}</th>
                      <th>{isAr ? "الإجراءات" : "Actions"}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {services.map((service) => (
                      <tr key={service.id}>
                        <td>
                          <div className="fw-semibold">
                            {service.titleEn || service.titleAr || `#${service.id}`}
                          </div>
                          <div className="small text-muted">
                            {(isAr ? service.shortDescriptionAr : service.shortDescriptionEn) ||
                              service.rejectionReason ||
                              service.slug}
                          </div>
                        </td>
                        <td>
                          <span className={`badge rounded-pill ${getStatusBadgeClass(service.approvalStatus)}`}>
                            {getStatusLabel(service.approvalStatus, isAr)}
                          </span>
                        </td>
                        <td>{formatMoney(service.price, service.currency)}</td>
                        <td>{service.ordersCount}</td>
                        <td>
                          <div className="d-flex gap-2 flex-wrap">
                            <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => handleEditService(service)}>
                              {isAr ? "تعديل" : "Edit"}
                            </button>
                            <button type="button" className="btn btn-sm btn-outline-danger" onClick={() => handleDeleteService(service)}>
                              {isAr ? "حذف" : "Delete"}
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
